/**
 * Restaura botões Comprar / Carrinho ao voltar do checkout (bfcache).
 * Script clássico (sem module) — sempre ativo após pageshow/pagehide.
 */
(function () {
  var SELECTOR = '[data-md-buy-now], [data-md-add-cart], [data-md-sticky-add]';

  function clearBusyDom() {
    document.querySelectorAll(SELECTOR).forEach(function (btn) {
      btn.classList.remove('md-pdp__btn--busy');
      btn.removeAttribute('aria-busy');
      delete btn.dataset.mdSubmitting;
    });
  }

  function resetAll() {
    clearBusyDom();
    if (window.MercadaoPdpCommerce && typeof window.MercadaoPdpCommerce.resetInstances === 'function') {
      window.MercadaoPdpCommerce.resetInstances();
    }
  }

  window.addEventListener('pageshow', resetAll);
  window.addEventListener('pagehide', clearBusyDom);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetAll();
  });

  window.MercadaoPdpCommerce = window.MercadaoPdpCommerce || {};
  window.MercadaoPdpCommerce.hardReset = resetAll;
})();
